import Vue from "vue";
import Router from "vue-router";
import { Form } from "vant";
// 富文本显示
const htmlPage = resolve =>
	require(["@/components/htmlPage/htmlPage.vue"], resolve);

// 融资
const financing = resolve =>
	require(["@/components/financing/financing.vue"], resolve);
const financingRecord = resolve =>
	require(["@/components/financing/financingRecord.vue"], resolve);
const financingRecordDetail = resolve =>
	require(["@/components/financing/financingRecordDetail.vue"], resolve);
const financingRegister = resolve =>
	require(["@/components/financing/financingRegister.vue"], resolve);
const financingDetail = resolve =>
	require(["@/components/financing/financingDetail.vue"], resolve);
const financingRecordsList = resolve =>
	require(["@/components/financing/financingRecordsList.vue"], resolve);
const trialPage = resolve =>
	require(["@/components/financing/trialPage.vue"], resolve);
const financingList = resolve =>
	require(["@/components/financing/financingList.vue"], resolve);

// 登录
const login = resolve => require(["@/components/login.vue"], resolve);
const register = resolve => require(["@/components/register.vue"], resolve);
const evpi = resolve => require(["@/components/evpi.vue"], resolve);
const protocol1 = resolve =>
	require(["@/components/protocolComponents/protocol1.vue"], resolve);
const protocol2 = resolve =>
	require(["@/components/protocolComponents/protocol2.vue"], resolve);
const protocol3 = resolve =>
	require(["@/components/protocolComponents/protocol3.vue"], resolve);

// 手势密码
const setGestures = resolve =>
	require(["@/components/gestures/setGestures.vue"], resolve);
// 预览页
const previewPage = resolve => require(["@/components/nav/previewPage.vue"], resolve);
//底部导航
const index = resolve => require(["@/components/index.vue"], resolve);
const borrow = resolve => require(["@/components/nav/borrow.vue"], resolve);
const payback = resolve => require(["@/components/nav/payBack.vue"], resolve);
const user = resolve => require(["@/components/nav/user.vue"], resolve);
const message = resolve => require(["@/components/message.vue"], resolve);
const citySelect = resolve =>
	require(["@/components/nav/citySelect.vue"], resolve);
//产品使用
const productDetail = resolve =>
	require(["@/components/product/productDetail.vue"], resolve);
const agentProductDetail = resolve =>
	require(["@/components/product/agentProductDetail.vue"], resolve);
const success = resolve =>
	require(["@/components/product/success.vue"], resolve);
const productProgress = resolve =>
	require(["@/components/product/productProgress.vue"], resolve);
const loan = resolve => require(["@/components/product/loan.vue"], resolve);
const loanSuccess = resolve =>
	require(["@/components/product/loanSuccess.vue"], resolve);
//use操作
const infoList = resolve =>
	require(["@/components/user/infoList.vue"], resolve);
const myLoan = resolve => require(["@/components/user/myLoan.vue"], resolve);
const introduce = resolve =>
	require(["@/components/user/introduce.vue"], resolve);
const question = resolve =>
	require(["@/components/user/question.vue"], resolve);
const aboutUs = resolve => require(["@/components/user/aboutUs.vue"], resolve);
const setting = resolve => require(["@/components/user/setting.vue"], resolve);
const opinion = resolve => require(["@/components/user/opinion.vue"], resolve);
const about = resolve => require(["@/components/user/about.vue"], resolve); // 关于
const threeCooperation = resolve => require(["@/components/user/threeCooperation.vue"], resolve); // 第三方合作目录
const modifyPhone = resolve =>
	require(["@/components/user/modifyPhone.vue"], resolve);
const chooseIdentity = resolve =>
	require(["@/components/user/chooseIdentity.vue"], resolve);
//还款
const paymentHistory = resolve =>
	require(["@/components/payBack/paymentHistory.vue"], resolve);
const earlierPay = resolve =>
	require(["@/components/payBack/earlierPay.vue"], resolve);
const earlierPayforDay = resolve =>
	require(["@/components/payBack/earlierPayforDay.vue"], resolve);
const payPlan = resolve =>
	require(["@/components/payBack/payPlan.vue"], resolve);
const payDetail = resolve =>
	require(["@/components/payBack/payDetail.vue"], resolve);
const payResult = resolve =>
	require(["@/components/payBack/payResult.vue"], resolve);
//信息采集
const identity = resolve =>
	require(["@/components/infoCollect/identity.vue"], resolve);
const livingResult = resolve =>
	require(["@/components/infoCollect/living.vue"], resolve);
const personal = resolve =>
	require(["@/components/infoCollect/personal.vue"], resolve);
const bank_card = resolve =>
	require(["@/components/infoCollect/bank_card.vue"], resolve);
const addBankCard = resolve =>
	require(["@/components/infoCollect/addBankCard.vue"], resolve);
const relation = resolve =>
	require(["@/components/infoCollect/relation.vue"], resolve);
const car = resolve => require(["@/components/infoCollect/car.vue"], resolve);
const carDetail = resolve =>
	require(["@/components/infoCollect/carDetail.vue"], resolve);
const house = resolve =>
	require(["@/components/infoCollect/house.vue"], resolve);
const houseDetail = resolve =>
	require(["@/components/infoCollect/houseDetail.vue"], resolve);
const personalList = resolve =>
	require(["@/components/infoCollect/personalList.vue"], resolve);
const personlUnbundling = resolve =>
	require(["@/components/infoCollect/personlUnbundling.vue"], resolve);
// 个人资质信息补充页
const personalQualification = resolve =>
	require(["@/components/infoCollect/personalQualification.vue"], resolve);
// 企业资质信息补充页
const enterpriseQualification = resolve =>
	require(["@/components/infoCollect/enterpriseQualification.vue"], resolve);
const enterprise = resolve =>
	require(["@/components/infoCollect/enterprise.vue"], resolve);
const enterpriseUnbundling = resolve =>
	require(["@/components/infoCollect/enterpriseUnbundling.vue"], resolve);
const unbundlingPage = resolve =>
	require(["@/components/infoCollect/unbundlingPage.vue"], resolve);
const enterpriseDetail = resolve =>
	require(["@/components/infoCollect/enterpriseDetail.vue"], resolve);
const credit = resolve =>
	require(["@/components/infoCollect/credit.vue"], resolve);
const salary = resolve =>
	require(["@/components/infoCollect/salary.vue"], resolve);
const social = resolve =>
	require(["@/components/infoCollect/social.vue"], resolve);
const accumulationFund = resolve =>
	require(["@/components/infoCollect/accumulationFund.vue"], resolve);
const insurancePolicy = resolve =>
	require(["@/components/infoCollect/insurancePolicy.vue"], resolve);
const marketHome = resolve =>
	require(["@/components/marketCenter/marketHome.vue"], resolve);
const selectEnterprise = resolve =>
	require(["@/components/marketCenter/selectEnterprise.vue"], resolve);
const enterpriseEditorFirst = resolve =>
	require(["@/components/marketCenter/enterpriseEditorFirst.vue"], resolve);
const enterpriseEditorCar = resolve =>
	require(["@/components/marketCenter/enterpriseEditorCar.vue"], resolve);
const enterpriseEditorHouse = resolve =>
	require(["@/components/marketCenter/enterpriseEditorHouse.vue"], resolve);
const enterpriseEditorLast = resolve =>
	require(["@/components/marketCenter/enterpriseEditorLast.vue"], resolve);

// 政策资讯
const policyList = resolve =>
	require(["@/components/policy/policyList.vue"], resolve);

// 智能匹配
const loanWill = resolve => require(["@/components/intelligentMatching/loanWill.vue"], resolve);
const matchingFailure = resolve => require(["@/components/intelligentMatching/matchingFailure.vue"], resolve);
const personalCredit = resolve => require(["@/components/intelligentMatching/personalCredit.vue"], resolve);
const personalInformation = resolve => require(["@/components/intelligentMatching/personalInformation.vue"], resolve);
const loanDemand = resolve => require(["@/components/intelligentMatching/loanDemand.vue"], resolve);
const enterpriseCredit = resolve => require(["@/components/intelligentMatching/enterpriseCredit.vue"], resolve);
const enterpriseInformation = resolve => require(["@/components/intelligentMatching/enterpriseInformation.vue"], resolve);
const matchingLoading = resolve => require(["@/components/intelligentMatching/matchingLoading.vue"], resolve);
const matchingSuccess = resolve => require(["@/components/intelligentMatching/matchingSuccess.vue"], resolve);
const matchingProducts = resolve => require(["@/components/intelligentMatching/matchingProducts.vue"], resolve); // 匹配产品落地页

// 武侯中转页
const whMiddlePage = resolve => require(["@/components/nav/whMiddlePage.vue"], resolve);
// 中原消金活动页
const zyxjGold = resolve => require(["@/components/threeLinks/zyxjGold.vue"], resolve);
// 中原消金中转页
const zyxjMiddlePage = resolve => require(["@/components/threeLinks/zyxjMiddlePage.vue"], resolve);
// 九宫格抽奖
// const luckyDraw = resolve => require(["@/components/luckyDraw/luckyDraw.vue"], resolve);


//农业银行
const agriculturalBank = resolve =>
	require(["@/components/agriculturalBank"], resolve);
const taxpayerInfo = resolve =>
	require(["@/components/agriculturalBank/taxpayerInfo.vue"], resolve);
const searchResult = resolve =>
	require(["@/components/agriculturalBank/searchResult.vue"], resolve);

const share = resolve => require(["@/components/share/share.vue"], resolve);
const mark = resolve => require(["@/components/mark/index.vue"], resolve);

// 平台介绍
const cooperation = resolve => require(["@/components/introduce/cooperation.vue"], resolve);
const calculator = resolve => require(["@/components/nav/calculator.vue"], resolve);
const calculatorResult = resolve => require(["@/components/nav/calculatorResult.vue"], resolve);
const introduceDetail = resolve => require(["@/components/introduce/introduceDetail.vue"], resolve);
const history = resolve => require(["@/components/introduce/history.vue"], resolve);

// 优享服务 enjoyBestService
const enjoyBestService = resolve => require(["@/components/enjoyBestService/index.vue"], resolve);

// 入场查询界面
const loginBank = resolve => require(["@/components/bankQuery/loginBank.vue"], resolve);
const queryParams = resolve => require(["@/components/bankQuery/queryParams.vue"], resolve);
const screenOrder = resolve => require(["@/components/bankQuery/screenOrder.vue"], resolve);
const queryBusinessResult = resolve => require(["@/components/bankQuery/queryBusinessResult.vue"], resolve);
const queryFundResult = resolve => require(["@/components/bankQuery/queryFundResult.vue"], resolve);
const queryHouseResult = resolve => require(["@/components/bankQuery/queryHouseResult.vue"], resolve);
const queryResultDetail = resolve => require(["@/components/bankQuery/queryResultDetail.vue"], resolve);

// 贷小二查询
const loginBorrowSmall2 = resolve => require(["@/components/borrowSmall2/login.vue"],resolve) // 贷小二登录
const queryParamsBs = resolve => require(["@/components/borrowSmall2/queryParamsBs.vue"],resolve) // 贷小二数据查询
const queryHouseResultBs = resolve => require(["@/components/borrowSmall2/queryHouseResultBs.vue"],resolve) // 贷小二不动产查询结果
const queryResultDetailBs = resolve => require(["@/components/borrowSmall2/queryResultDetailBs.vue"],resolve) // 贷小二不动产查询结果详情
const queryFundResultBs = resolve => require(["@/components/borrowSmall2/queryFundResultBs.vue"],resolve) // 贷小二公积金查询结果详情
const queryMarriageBs = resolve => require(["@/components/borrowSmall2/queryMarriageBs.vue"], resolve) // 贷小二婚姻查询结果详情

// 联通页面
const unicomLogin = resolve => require(["@/components/unicom/login.vue"], resolve) // 贷小二登录

// 交通银行页面
const trafficHome = resolve => require(["@/components/trafficBank/trafficHome.vue"], resolve) // 交通银行查询首页
const trafficSubmit = resolve => require(["@/components/trafficBank/trafficSubmit.vue"], resolve) // 交通银行查询结果提交页面
const trafficResult = resolve => require(["@/components/trafficBank/trafficResult.vue"], resolve) // 交通银行提交结果页面

Vue.use(Router);

const router = new Router({
	mode: "history", // keep alive需要hash模式才能缓存, 所有从history改成hash
	routes: [
		{ path: "/", redirect: "/index/borrow" },
		{
			path: "/mark",
			component: mark,
			meta: { title: "", isHeader: false, isLogin: false }
		},
		{
			path: "/loanWill",
			component: loanWill,
			meta: { title: "贷款意向", isHeader: false, isLogin: true }
		},
		{
			path: "/matchingFailure",
			component: matchingFailure,
			meta: { title: "匹配结果过渡页", isHeader: false, isLogin: true }
		},
		{
			path: "/personalCredit",
			component: personalCredit,
			meta: { title: "个人信贷/抵押信息", isHeader: false, isLogin: true }
		},
		{
			path: "/personalInformation",
			component: personalInformation,
			meta: { title: "个人基本信息", isHeader: false, isLogin: true }
		},
		{
			path: "/enterpriseCredit",
			component: enterpriseCredit,
			meta: { title: "企业信贷/抵押信息", isHeader: false, isLogin: true }
		},
		{
			path: "/enterpriseInformation",
			component: enterpriseInformation,
			meta: { title: "企业基本信息", isHeader: false, isLogin: true }
		},
		{
			path: "/loanDemand",
			component: loanDemand,
			meta: { title: "贷款诉求", isHeader: false, isLogin: true }
		},
		{
			path: "/matchingLoading",
			component: matchingLoading,
			meta: { title: "匹配动画", isHeader: false, isLogin: true }
		},
		{
			path: "/matchingSuccess",
			component: matchingSuccess,
			meta: { title: "身份新增成功", isHeader: false, isLogin: true }
		},
		{
			path: "/matchingProducts",
			component: matchingProducts,
			meta: { title: "匹配产品落地页", isHeader: false, isLogin: true }
		},
		{
			path: "/whMiddlePage",
			component: whMiddlePage,
			meta: { title: "跳转小程序页面", isHeader: false, isLogin: false }
		},
		{
			path: "/zyxjGold",
			component: zyxjGold,
			meta: { title: "中原消金活动页", isHeader: false, isLogin: false }
		},
		{
			path: "/zyxjMiddlePage",
			component: zyxjMiddlePage,
			meta: { title: "中原消金中转页", isHeader: false, isLogin: false }
		},
		// {
		// 	path: "/luckyDraw",
		// 	component: luckyDraw,
		// 	meta: { title: "九宫格抽奖", isHeader: false, isLogin: false }
		// },
		{
			path: "/login",
			component: login,
			meta: { title: "登录", isHeader: false, isLogin: false }
		},
		{
			path: "/loginBank",
			component: loginBank,
			meta: { title: "登录", isHeader: false, isLogin: false }
		},
		{
			path: "/previewPage",
			component: previewPage,
			meta: { title: "预览页", isHeader: false, isLogin: false }
		},
		{
			path: "/setGestures",
			component: setGestures,
			meta: { title: "设置手势密码", isHeader: false, isLogin: false }
		},
		// {path: '/register', component: register, meta: {title: '注册', isHeader: false, isLogin: false}},
		// {path: '/evpi', component: evpi, meta: {title: '完善信息', isHeader: false, isLogin: false}},
		{
			path: "/protocol1",
			component: protocol1,
			meta: { title: "平台服务协议", isHeader: true, isLogin: false }
		},
		{
			path: "/protocol2",
			component: protocol2,
			meta: { title: "税务授权书", isHeader: true, isLogin: false }
		},
		{
			path: "/protocol3",
			component: protocol3,
			meta: { title: "扣款授权书", isHeader: true, isLogin: false }
		},

		// 富文本显示
		{
			path: "/htmlPage",
			component: htmlPage,
			meta: { title: "详情", isHeader: false, isLogin: false }
		},

		// 融资
		{
			path: "/financing",
			component: financing,
			meta: { title: "提交申请信息", isHeader: true, isLogin: true }
		},
		{
			path: "/financingRecord",
			component: financingRecord,
			meta: { title: "融资需求", isHeader: true, isLogin: true }
		},
		{
			path: "/financingRecordDetail",
			component: financingRecordDetail,
			meta: { title: "记录详情", isHeader: true, isLogin: true }
		},
		{
			path: "/financingDetail",
			name: "financingDetail",
			component: financingDetail,
			meta: { title: "企业经营贷款", isHeader: false, isLogin: false }
		},
		{
			path: "/financingRegister",
			name: "financingRegister",
			component: financingRegister,
			meta: { title: "申请表单", isHeader: false, isLogin: false }
		},
		// {path: '/financingDetail', component: financingDetail, meta: {title: '企业经营贷款', isHeader: false, isLogin: true}},
		{
			path: "/financingRecordsList",
			name: "financingRecordsList",
			component: financingRecordsList,
			meta: {
				title: "融资记录",
				isHeader: true,
				isLogin: true,
				keepAlive: true
			}
		},
		{
			path: "/trialPage",
			component: trialPage,
			meta: { title: "产品试算", isHeader: false, isLogin: true }
		},
		{
			path: "/financingList",
			name: "financingList",
			component: financingList,
			meta: {
				title: "融资",
				isHeader: false,
				isLogin: false,
				keepAlive: true
			}
		},
		// {path: '/financingList', component: financingList, meta: {title: '融资', isHeader: false, isLogin: true}},

		// 政策资讯

		//底部导航
		{
			path: "/index",
			component: index,
			redirect: "/index/borrow",
			children: [
				{
					path: "borrow",
					component: borrow,
					meta: { title: "兴川贷", isHeader: false, isLogin: false }
				},
				{
					path: "policy",
					component: policyList,
					meta: { title: "政策资讯", isHeader: false, isLogin: false }
				},
				// {path: 'borrow', component: borrow, meta: {title: '兴川贷', isHeader: false, isLogin: true}},
				// {path: 'policy', component: policyList, meta: {title: '政策资讯', isHeader: false, isLogin: true}},
				{
					path: "user",
					component: user,
					meta: { title: "我的", isHeader: false, isLogin: true }
				}
			]
		},
		{
			path: "/message",
			component: message,
			meta: { title: "消息", isHeader: false, isLogin: true }
		},
		{
			path: "/citySelect",
			component: citySelect,
			meta: { title: "城市选择", isHeader: true, isLogin: false }
		},

		//产品使用
		{
			path: "/productDetail",
			component: productDetail,
			meta: { title: "产品详情", isHeader: false, isLogin: false }
		},
		{
			path: "/agentProductDetail",
			component: agentProductDetail,
			meta: { title: "产品详情", isHeader: false, isLogin: false }
		},
		{
			path: "/success",
			component: success,
			meta: { title: "提交授权", isHeader: true, isLogin: true }
		},
		{
			path: "/productProgress",
			component: productProgress,
			meta: { title: "查看进度", isHeader: true, isLogin: true }
		},
		{
			path: "/loan",
			component: loan,
			meta: { title: "借款申请", isHeader: true, isLogin: true }
		},
		{
			path: "/loanSuccess",
			component: loanSuccess,
			meta: { title: "提交借款", isHeader: true, isLogin: true }
		},

		//use操作
		{
			path: "/infoList",
			component: infoList,
			meta: { title: "信息管理", isHeader: true, isLogin: true }
		},
		{
			path: "/myLoan",
			component: myLoan,
			meta: { title: "我的借款", isHeader: true, isLogin: true }
		},
		{
			path: "/introduce",
			component: introduce,
			meta: { title: "了解兴川贷", isHeader: true, isLogin: true }
		},
		{
			path: "/aboutUs",
			component: aboutUs,
			meta: { title: "关于我们", isHeader: true, isLogin: true }
		},
		{
			path: "/about",
			component: about,
			meta: { title: "关于", isHeader: true, isLogin: true }
		},
		{
			path: "/threeCooperation",
			component: threeCooperation,
			meta: { title: "第三方合作目录", isHeader: true, isLogin: false }
		},
		{
			path: "/question",
			component: question,
			meta: { title: "常见问题", isHeader: false, isLogin: true }
		},
		{
			path: "/setting",
			component: setting,
			meta: { title: "设置", isHeader: true, isLogin: true }
		},
		{
			path: "/opinion",
			component: opinion,
			meta: { title: "意见反馈", isHeader: true, isLogin: true }
		},
		{
			path: "/modifyPhone",
			component: modifyPhone,
			meta: { title: "变更绑定手机号码", isHeader: true, isLogin: true }
		},
		{
			path: "/chooseIdentity",
			component: chooseIdentity,
			meta: { title: "兴川贷", isHeader: true, isLogin: false }
		},
		//还款
		{
			path: "/paymentHistory",
			component: paymentHistory,
			meta: { title: "还款记录", isHeader: true, isLogin: true }
		},
		{
			path: "/earlierPay",
			component: earlierPay,
			meta: { title: "提前结清", isHeader: true, isLogin: true }
		},
		{
			path: "/earlierPayforDay",
			component: earlierPayforDay,
			meta: { title: "还款", isHeader: true, isLogin: true }
		},
		{
			path: "/payPlan",
			component: payPlan,
			meta: { title: "还款计划", isHeader: true, isLogin: true }
		},
		{
			path: "/payDetail",
			component: payDetail,
			meta: { title: "还款明细", isHeader: true, isLogin: true }
		},
		{
			path: "/payResult",
			component: payResult,
			meta: { title: "结清结果", isHeader: true, isLogin: true }
		},

		//信息采集
		{
			path: "/identity",
			component: identity,
			meta: { title: "身份认证", isHeader: false, isLogin: true }
		},
		{
			path: "/aliving",
			component: livingResult,
			meta: { title: "活体识别", isHeader: false, isLogin: true }
		},
		{
			path: "/personal",
			component: personal,
			meta: { title: "个人信息", isHeader: true, isLogin: true }
		},
		{
			path: "/bank_card",
			component: bank_card,
			meta: { title: "银行卡管理", isHeader: false, isLogin: true }
		},
		{
			path: "/addBankCard",
			component: addBankCard,
			meta: { title: "添加银行卡", isHeader: true, isLogin: true }
		},
		{
			path: "/relation",
			component: relation,
			meta: { title: "关联信息", isHeader: true, isLogin: true }
		},
		{
			path: "/car",
			component: car,
			meta: { title: "车产信息", isHeader: true, isLogin: true }
		},
		{
			path: "/carDetail",
			component: carDetail,
			meta: { title: "车产信息", isHeader: true, isLogin: true }
		},
		{
			path: "/house",
			component: house,
			meta: { title: "房产信息", isHeader: true, isLogin: true }
		},
		{
			path: "/houseDetail",
			component: houseDetail,
			meta: { title: "房产信息", isHeader: true, isLogin: true }
		},
		{
			path: "/personalList",
			component: personalList,
			meta: { title: "个人信息", isHeader: true, isLogin: true }
		},
		{
			path: "/personlUnbundling",
			component: personlUnbundling,
			meta: { title: "个人信息详情", isHeader: true, isLogin: true }
		},
		{
			path: "/personalQualification",
			component: personalQualification,
			meta: { title: "个人资质信息", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseQualification",
			component: enterpriseQualification,
			meta: { title: "企业资质信息", isHeader: true, isLogin: true }
		},
		{
			path: "/enterprise",
			component: enterprise,
			meta: { title: "企业信息", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseUnbundling",
			component: enterpriseUnbundling,
			meta: { title: "企业信息详情", isHeader: true, isLogin: true }
		},
		{
			path: "/unbundlingPage",
			component: unbundlingPage,
			meta: { title: "企业解绑", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseDetail",
			component: enterpriseDetail,
			meta: { title: "企业信息", isHeader: true, isLogin: true }
		},
		{
			path: "/credit",
			component: credit,
			meta: { title: "征信授权", isHeader: true, isLogin: true }
		},
		{
			path: "/salary",
			component: salary,
			meta: { title: "工资信息", isHeader: true, isLogin: true }
		},
		{
			path: "/social",
			component: social,
			meta: { title: "社保信息", isHeader: true, isLogin: true }
		},
		{
			path: "/accumulationFund",
			component: accumulationFund,
			meta: { title: "公积金信息", isHeader: true, isLogin: true }
		},
		{
			path: "/insurancePolicy",
			component: insurancePolicy,
			meta: { title: "保单信息", isHeader: true, isLogin: true }
		},
		// 企业登记详情
		{
			path: "/marketHome",
			component: marketHome,
			meta: { title: "企业登录", isHeader: true, isLogin: true }
		},
		{
			path: "/selectEnterprise",
			component: selectEnterprise,
			meta: { title: "选择企业", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseEditorCar",
			component: enterpriseEditorCar,
			meta: { title: "选择企业", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseEditorFirst",
			component: enterpriseEditorFirst,
			meta: { title: "选择企业", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseEditorHouse",
			component: enterpriseEditorHouse,
			meta: { title: "选择企业", isHeader: true, isLogin: true }
		},
		{
			path: "/enterpriseEditorLast",
			component: enterpriseEditorLast,
			meta: { title: "选择企业", isHeader: true, isLogin: true }
		},

		//分享中间页
		{
			path: "/share",
			component: share,
			meta: { title: "分享", isHeader: true, isLogin: false }
		},

		// 农行页面
		{
			path: "/agriculturalBank",
			component: agriculturalBank,
			meta: { title: "纳税e贷", isHeader: true, isLogin: true }
		},
		{
			path: "/taxpayerInfo",
			component: taxpayerInfo,
			meta: { title: "纳税人信息", isHeader: true, isLogin: true }
		},
		{
			path: "/searchResult",
			component: searchResult,
			meta: { title: "查询结果", isHeader: true, isLogin: true }
		},
		{
			path: "/cooperation",
			component: cooperation,
			meta: { title: "合作单位", isHeader: true, isLogin: false }
		},
		{
			path: "/calculator",
			component: calculator,
			meta: { title: "贷款计算器", isHeader: true, isLogin: false }
		},
		{
			path: "/introduceDetail",
			component: introduceDetail,
			meta: { title: "平台详情", isHeader: true, isLogin: false }
		},
		{
			path: "/enjoyBestService",
			component: enjoyBestService,
			meta: { title: "优享服务", isHeader: true, isLogin: false }
		},
		{
			path: "/history",
			component: history,
			meta: { title: "发展历程", isHeader: true, isLogin: false }
		},
		{
			path: "/calculatorResult",
			component: calculatorResult,
			meta: { title: "计算结果", isHeader: true, isLogin: false }
		},
		// 浦发银行查询功能,单独模块
		{
			path: "/loginBank",
			component: loginBank,
			meta: { title: "登录", isHeader: false, isLogin: false, isBankQuery: true }
		},
		{
			path: "/queryParams",
			component: queryParams,
			meta: { title: "数据查询", isHeader: true, isLogin: true, isBankQuery: true }
		},
		{
			path: "/queryBusinessResult",
			component: queryBusinessResult,
			meta: { title: "工商四要素验证结果", isHeader: true, isLogin: true, isBankQuery: true }
		},
		{
			path: "/queryResultDetail",
			component: queryResultDetail,
			meta: { title: "验证详情", isHeader: true, isLogin: true, isBankQuery: true }
		},
		{
			path: "/queryHouseResult",
			component: queryHouseResult,
			meta: { title: "不动产查询结果", isHeader: true, isLogin: true, isBankQuery: true }
		},
		{
			path: "/queryFundResult",
			component: queryFundResult,
			meta: { title: "个人公积金查询结果", isHeader: true, isLogin: true, isBankQuery: true }
		},
		// 贷小二模块
		{
			path: "/loginBorrowSmall2",
			component: loginBorrowSmall2,
			meta: { title: "贷小二登录", isHeader: false, isLogin: false, isBorrowSmall2: true }
		},
		{
			path: "/queryParamsBs",
			component: queryParamsBs,
			meta: { title: "贷小二数据查询", isHeader: true, isLogin: true, isBorrowSmall2: true }
		},
		{
			path: "/queryHouseResultBs",
			component: queryHouseResultBs,
			meta: { title: "贷小二不动产查询结果", isHeader: true, isLogin: true, isBorrowSmall2: true }
		},
		{
			path: "/queryResultDetailBs",
			component: queryResultDetailBs,
			meta: { title: "贷小二不动产查询结果详情", isHeader: true, isLogin: true, isBorrowSmall2: true }
		},
		{
			path: "/queryFundResultBs",
			component: queryFundResultBs,
			meta: { title: "贷小二公积金查询结果", isHeader: true, isLogin: true, isBorrowSmall2: true }
		},
		{
			path: "/queryMarriageBs",
			component: queryMarriageBs,
			meta: { title: "贷小二婚姻查询结果", isHeader: true, isLogin: true, isBorrowSmall2: true }
		},
		// 联通 unicomLogin
		{
			path: "/unicomLogin",
			component: unicomLogin,
			meta: { title: "联通登录", isHeader: false, isLogin: false, isBorrowSmall2: true }
		},
		// 交通银行-查询首页
		{
			path: "/trafficHome",
			component: trafficHome,
			meta: { title: "交通银行查询首页", isHeader: false, isLogin: false}
		},
		// 交通银行-查询结果提交
		{
			path: "/trafficSubmit",
			component: trafficSubmit,
			meta: { title: "交通银行查询提交页", isHeader: false, isLogin: false}
		},
		// 交通银行-查询结果提交
		{
			path: "/trafficResult",
			component: trafficResult,
			meta: { title: "交通银行提交结果页", isHeader: false, isLogin: false}
		},
		{
			path: "/screenOrder",
			component: screenOrder,
			meta: { title: "筛查预约页面", isHeader: false, isLogin: false}
		},
	]
});
let previewrouter=sessionStorage.getItem('previewFlag');
router.beforeEach((to, from, next) => {
	if (to.meta.isBankQuery) { // 银行查询界面
		let accountId = localStorage.getItem("accountId");
		localStorage.setItem("loginType", 'BankUser');
		if (to.meta.isLogin && !accountId) {
			localStorage.setItem("jumpLogin", window.location.href);
			router.replace({ path: "/loginBank" });
		} else {
			next();
		}
	} else if (to.meta.isBorrowSmall2) { // 贷小二数据查询页面
		let borrowSmall2Token = localStorage.getItem("borrowSmall2Token");
		localStorage.setItem("loginType", 'borrowSmall2User');
		if (to.meta.isLogin && !borrowSmall2Token) {
			localStorage.setItem("jumpLogin", window.location.href);
			router.replace({ path: "/loginBorrowSmall2" });
		} else {
			next();
		}
	} else { // 用户页面逻辑
		let dkId = localStorage.getItem("dkId");
		localStorage.removeItem('loginType')
		if (to.meta.isLogin && !dkId) {
			// next({path: '/login'})
			localStorage.setItem("jumpLogin", window.location.href);
			router.replace({ path: "/login" });
		} else {
			next();
		}
	}

	// var u = navigator.userAgent;
	// var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	// // XXX: 修复iOS版微信HTML5 History兼容性问题
	// if (isiOS && to.path != location.pathname) {
	// // 此处不可使用location.replace
	// 	location.assign(to.fullPath)
	// 	// router.replace({path: '/login'})
	// } else {
	// 	if (to.meta.isLogin && !dkId) {
	// 		// next({path: '/login'})
	// 		router.replace({path: '/login'})
	// 	} else {
	// 		next()
	// 	}
	// }
});

router.afterEach((to, from) => {
	if(previewrouter=='1'){
		// router.replace({ path: "/index/borrow?"+"preId="+sessionStorage.getItem('preId') });
	}
	window.scrollTo(0, 0);

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js